import { captureException } from '@sentry/react';
import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage } from 'firebase/messaging';
import { useEffect } from 'react';
import { getPushState } from '../../../helpers/validate';
import { useLocalStorageSubscribe } from '../../../hooks/use-local-storage-subscribe';
import { handlePrepareData, HandlePrepareDataArgs } from '../notification-helpers';
import { firebaseConfig } from './config';
import { FirebaseBgUpdateProps, useFirebaseBgUpdate } from './use-firebase-bg-update';
import { useFirebaseRegister } from './use-firebase-register';

const app = initializeApp(firebaseConfig);
const firebaseMessaging = getMessaging(app);

interface FirebaseProps extends FirebaseBgUpdateProps {
  handleAddIndexedDb: HandlePrepareDataArgs['handleAddIndexedDb'];
}

export const useFirebase = (props: FirebaseProps) => {
  const { handleAddIndexedDb, handleGetNotifications } = props;
  useFirebaseRegister({ firebaseMessaging });
  useLocalStorageSubscribe();

  const isNotificationsEnabled = getPushState();

  useEffect(() => {
    try {
      const sub = onMessage(firebaseMessaging, async (payload) => {
        if (!isNotificationsEnabled) return;
        await handlePrepareData({ payload, handleAddIndexedDb });
      });
      return () => sub();
    } catch {
      captureException(new Error(`Catched: firebase SDK is inavailable`), {
        tags: { firebase: 'inavailable' },
      });
    }
  }, [isNotificationsEnabled]);

  useFirebaseBgUpdate({ handleGetNotifications });
};
